import {
  Box,
  CircularProgress,
  Collapse,
  Grid,
  TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import Switch from "react-switch";
import * as Utils from '../../commons/utils/Utils.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment"; 

const FILTER_STATE_INIT = {
tipo: null,
region: null,
subRegion: '',
base: null,
centroCosto: null,
motivo:'',
dominio: '',
modelo: '',
transportadora: [],
esReserva: '',
fechaRetornoDesde: null,
fechaRetornoHasta: null
}

const QUERY_INIT = {
tipo: '',
region: '',
subRegion: '',
base: '',
centroCosto: '',
motivo:'',
dominio: '',
modelo: '',
transportadora: [],
esReserva: '',
fechaRetornoDesde: '',
fechaRetornoHasta: ''
}

const handleInitFilters = () => {
let filterInit = JSON.parse(JSON.stringify(FILTER_STATE_INIT))
let storage = JSON.parse(window.localStorage.getItem('DisponibilidadGridFilter'))
if(storage && storage.activo && storage.filtros){
  filterInit = storage.filtros
}
return filterInit
}

const DisponibilidadGridFilters = (props) => {
const intl = useIntl();

const [init,setInit] = useState(false)
const [filtersLoading, setFiltersLoading] = useState(false);
const [isEachFilterLoading, setIsEachFilterLoading] = useState({
  tipos: true,
  dominio: true,
  modelo: true,
  regiones: true,
  motivo:true,
  subRegiones: true,
  bases: true,
  cecos: true,
  fechaRetornoDesde: true,
  fechaRetornoHasta: true,
})
const [filtersState, setFiltersState] = useState(handleInitFilters)
const [fechaRetornoDesde, setFechaRetornoDesde] = useState(null);
const [fechaRetornoHasta, setFechaRetornoHasta] = useState(null);

//Filters Selects values
const [tipos, setTipos] = useState([])
const [regiones, setRegiones] = useState([])
const [subRegiones, setSubRegiones] = useState([])
const [bases, setBases] = useState([])
const [centrosCostos, setCentrosCostos] = useState([])
const [motivos, setMotivos] = useState([])
const [validatorSearch, setValidatorSearch] = useState(false)
const [transportadora, setTransportadora] = useState(null);
const [transportadoras, setTransportadoras] = useState([]);

useEffect(() => {
  fetchData()
  initFilter()
}, []);

useEffect(() => {
  if(props.filterResetInputs){
    setFiltersState(JSON.parse(JSON.stringify(FILTER_STATE_INIT)));
    window.localStorage.setItem('DisponibilidadGridFilter',JSON.stringify({activo: false, filtros: FILTER_STATE_INIT}));
  }
},[props.filterResetInputs])

useEffect(() => {
  !props.dropdownActive && props.setFilterResetInputs(false)
  !props.dropdownActive && setFiltersLoading(false)
}, [props.dropdownActive]);


const fetchData = () => {
  setFiltersLoading(true)

  const loadFilters = (url, setter, filtro) => {
    Utils.getData(url)
    .then(data => setter(data || []))
    .catch(err => console.log(err))
    .finally(() => setIsEachFilterLoading(prevState => ({...prevState, [filtro]: false})));
  }
  
  
  loadFilters('/modelo-tipos/select', setTipos, 'tipos');
  loadFilters('/regiones/select', setRegiones, 'regiones');
  loadFilters('/bases/select-filtered-by-user/movil', setBases, 'bases');
  loadFilters('/centros-costos/select', setCentrosCostos, 'cecos');
  loadFilters('/subregiones/select-all', setSubRegiones, 'subRegiones');
  loadFilters('/motivos/ociosidad/select', setMotivos, 'motivo');
  loadFilters('/transportadoras', setTransportadoras, 'transportadoras');
}

const initFilter = () => {
  setFiltersLoading(true);
  let query = {}

  if(props.persisteFiltros || validatorNotNull()){
    props.setSearchActive(true);
  }
  
  query = queryTable();
  
  if(props.kpi){
    props.handleAlertClick(props.kpi.filter)
  }
  setInit(true)
  
  window.localStorage.setItem('DisponibilidadGridFilter',JSON.stringify({activo: props.persisteFiltros, filtros: filtersState}));
  props.setFilterQuery(query);
  setFiltersLoading(false)
  return;
}

const queryTable = () => {
  let query = {}
  query = JSON.parse(JSON.stringify(filtersState));
  query['tipo'] = filtersState.tipo ? filtersState.tipo.value : ''
  query['region'] = filtersState.region ? filtersState.region.value : ''
  query['subRegion'] = filtersState.subRegion ? filtersState.subRegion.value : ''
  query['base'] = filtersState.base ? filtersState.base.value : ''
  query['centroCosto'] = filtersState.centroCosto ? filtersState.centroCosto.value : ''
  query['dominio'] = filtersState.dominio ? filtersState.dominio : ''
  query['modelo'] = filtersState.modelo ? filtersState.modelo : ''
  query['motivo'] = filtersState.motivo ? filtersState.motivo.value : ''
  query['transportadora'] = filtersState.transportadora ? filtersState.transportadora.map(e => e.id).join(',') : ''
  query['esReserva'] = filtersState.esReserva ? filtersState.esReserva.value : ''
  query['fechaRetornoDesde'] = filtersState.fechaRetornoDesde ? moment(filtersState.fechaRetornoDesde).format('YYYY-MM-DD') : '';
  query['fechaRetornoHasta'] = filtersState.fechaRetornoHasta ? moment(filtersState.fechaRetornoHasta).format('YYYY-MM-DD') : '';
  return query;
}

const handleChange = (name, object) => {
      try {
          // Actualizar el estado aunque no haya un cambio en el localStorage
          setFiltersState((prevState) => {
              const updatedFiltersState = { ...prevState, [name]: object };                

              // Guardar en localStorage solo si la persistencia está habilitada
              if (props.persisteFiltros) {
                  window.localStorage.setItem(
                      'DisponibilidadGridFilter',
                      JSON.stringify({
                          activo: props.persisteFiltros,
                          filtros: updatedFiltersState
                      })
                  );                    
              }
              return updatedFiltersState; // Retornar el nuevo estado
          });
      } catch (error) {
          console.error("Error al manejar el cambio de filtros:", error);
      }
  };


useEffect(() => {
  if(init){
    if(props.persisteFiltros){
      window.localStorage.setItem('DisponibilidadGridFilter', JSON.stringify({activo: true, filtros: filtersState}));
    }
    else{
      setFiltersState(JSON.parse(JSON.stringify(FILTER_STATE_INIT)));
      props.setFilterQuery(JSON.parse(JSON.stringify(QUERY_INIT)));
      window.localStorage.setItem('DisponibilidadGridFilter',JSON.stringify({activo: false, filtros: FILTER_STATE_INIT}));
    } 
  }
},[props.persisteFiltros])

useEffect(() => {
  setValidatorSearch(validator());
},[filtersState])

const validator = () => {
  var result = Object.entries(filtersState);
  for (var index in result){
    if(Array.isArray(result[index][1])){
      if(result[index][1].length > 0 ){
        return false
      }
    }else{
      if(result[index][1]){
        return false
      }
    }
  }
  return true
}

const validatorNotNull = () => {
  var result = Object.entries(filtersState);
  for (var index in result){
    if(Array.isArray(result[index][1])){
      if(result[index][1].length > 0){
        return true
      }
    }else{
      if(result[index][1]){
        return true
      }
    }
  }
  return false
}

const handleSubmit = (event) => {
  props.handleFilterChange();
  event.preventDefault();
  props.setSearchActive(true)
  let query = queryTable();
  props.setFilterQuery(query);
  return;
}

const onChangePersistentFilter = (value) => {
  window.localStorage.setItem('DisponibilidadGridFilter', JSON.stringify({activo: value, filtros: filtersState}));
  props.setPersisteFiltros(value)
}

const handleSubmitInto = (event) => {
  if(!props.loading && !validatorSearch){
    handleSubmit(event);
  }
  event.preventDefault();
}
return (
  <>
  {init &&
    <Collapse in={props.dropdownActive}>
      <Grid container item xs={12} spacing={3} style={{marginBottom:20}}>
        <Grid component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <TextField
              label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_dominio.label", defaultMessage: "Dominio" })}
              placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_dominio.placeholder", defaultMessage: "Dominio" })}
              name="dominio"
              value={filtersState.dominio}
              onChange={(e) => handleChange('dominio', e.target.value)}
              disabled={filtersLoading}
              className="col-12"
            />
          </form>
        </Grid>
        <Grid component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <TextField
              label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_modelo.label", defaultMessage: "Modelo" })}
              placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_modelo.placeholder", defaultMessage: "Modelo" })}
              name="modelo"
              value={filtersState.modelo}
              onChange={(e) => handleChange('modelo', e.target.value)}
              disabled={filtersLoading}
              className="col-12"
            />
          </form>
        </Grid>
        <Grid component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <Autocomplete
              size="small"
              name="tipo"
              disabled={isEachFilterLoading.tipos}
              options={tipos}
              value={filtersState.tipo}
              defaultValue={null}
              getOptionLabel={(option) => option ? option.label : ""}
              onChange={(e, value) => handleChange('tipo', value)}
              renderInput={(params) => (
                <TextField {...params} variant="standard"
                  label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_tipo.label", defaultMessage: "Tipo" })}
                  placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_tipo.placeholder", defaultMessage: "Tipo" })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isEachFilterLoading.tipos ? (
                          <CircularProgress color="inherit" size={21} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </form>
        </Grid>
        <Grid component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <Autocomplete
              size="small"
              name="region"
              disabled={isEachFilterLoading.regiones}
              options={regiones}
              value={filtersState.region}
              defaultValue={null}
              getOptionLabel={(option) => option ? option.label : ""}
              onChange={(e, value) => handleChange('region', value)}
              renderInput={(params) => (
                <TextField {...params} variant="standard"
                  label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_region.label", defaultMessage: "Región" })}
                  placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_region.placeholder", defaultMessage: "Región" })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isEachFilterLoading.regiones ? (
                          <CircularProgress color="inherit" size={21} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </form>
        </Grid>
        <Grid component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <Autocomplete
              size="small"
              name="subRegion"
              disabled={isEachFilterLoading.subRegiones}
              options={subRegiones}
              value={filtersState.subRegion}
              defaultValue={null}
              getOptionLabel={(option) => option ? option.label : ""}
              onChange={(e, value) => handleChange('subRegion', value)}
              renderInput={(params) => (
                <TextField {...params} variant="standard"
                  label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_subRegion.label", defaultMessage: "Sub.Región" })}
                  placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_subRegion.placeholder", defaultMessage: "Sub.Región" })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isEachFilterLoading.subRegiones ? (
                          <CircularProgress color="inherit" size={21} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </form>
        </Grid>
        <Grid component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <Autocomplete
              size="small"
              name="base"
              disabled={isEachFilterLoading.bases}
              options={bases}
              value={filtersState.base}
              defaultValue={null}
              getOptionLabel={(option) => option ? option.label : ""}
              onChange={(e, value) => handleChange('base', value)}
              renderInput={(params) => (
                <TextField {...params} variant="standard"
                  label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_base.label", defaultMessage: "Base" })}
                  placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_base.placeholder", defaultMessage: "Base" })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isEachFilterLoading.bases ? (
                          <CircularProgress color="inherit" size={21} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </form>
        </Grid>
        <Grid component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <Autocomplete
              size="small"
              name="centroCosto"
              disabled={isEachFilterLoading.cecos}
              options={centrosCostos}
              value={filtersState.centroCosto}
              defaultValue={null}
              getOptionLabel={(option) => option ? option.label : ""}
              onChange={(e, value) => handleChange('centroCosto', value)}
              renderInput={(params) => (
                <TextField {...params} variant="standard"
                  label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_centroCosto.label", defaultMessage: "Centro de Costos" })}
                  placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_centroCosto.placeholder", defaultMessage: "Centro de Costos" })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isEachFilterLoading.cecos ? (
                          <CircularProgress color="inherit" size={21} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </form>
        </Grid>
        <Grid component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <Autocomplete
              size="small"
              name="motivo"
              disabled={isEachFilterLoading.motivo}
              options={motivos}
              value={filtersState.motivo}
              defaultValue={null}
              getOptionLabel={(option) => option ? option.label : ""}
              onChange={(e, value) => handleChange('motivo', value)}
              renderInput={(params) => (
                <TextField {...params} variant="standard"
                  label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_motivo.label", defaultMessage: "Motivo" })}
                  placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_motivo.placeholder", defaultMessage: "Motivo" })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isEachFilterLoading.motivo ? (
                          <CircularProgress color="inherit" size={21} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </form>
        </Grid>
          <Grid component={Box} item xs={3}>
            <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <DatePicker
                  selected={filtersState.fechaRetornoDesde}
                  onChange={date => [setFechaRetornoDesde(date), handleChange('fechaRetornoDesde', date)]}
                  dateFormat="DD/MM/yyyy"
                  customInput={
                    <TextField
                      value={filtersState.fechaRetornoDesde ? moment(filtersState.fechaRetornoDesde).format('DD/MM/yyyy') : ''}
                      label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_fecha_retorno_desde.label", defaultMessage: "Retorno Desde" })}
                      placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_fecha_retorno_desde.placeholder", defaultMessage: "Retorno Desde" })}
                      className="form-control date-picker-placeholder"
                      style={{ width: 120 }}
                      InputProps={{ readOnly: true }}
                    />
                  }
                />
                <DatePicker
                  selected={filtersState.fechaRetornoHasta}
                  onChange={date => [setFechaRetornoHasta(date), handleChange('fechaRetornoHasta', date)]}
                  dateFormat="DD/MM/yyyy"
                  customInput={
                    <TextField
                      value={filtersState.fechaRetornoHasta ? moment(filtersState.fechaRetornoHasta).format('DD/MM/yyyy') : ''}
                      label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_fecha_retorno_hasta.label", defaultMessage: "Retorno Hasta" })}
                      placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_fecha_retorno_hasta.placeholder", defaultMessage: "Retorno Hasta" })}
                      className="form-control date-picker-placeholder"
                      style={{ width: 120 }}
                      InputProps={{ readOnly: true }}
                    />
                  }
                />
              </div>
            </form>
          </Grid>
        <Grid {...!props.columnsEnabled.transportadora && { display: "none" }} component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <Autocomplete
              size="small"
              name="transportadora"
              multiple={true}
              disabled={filtersLoading}
              options={transportadoras}
              value={filtersState.transportadora ? filtersState.transportadora : []}
              defaultValue={[]}
              getOptionLabel={(option) => option ? option.nombre : ""}
              onChange={(e, value) => handleChange("transportadora", value)}
              renderInput={(params) => (
              <TextField {...params} variant="standard" 
                label={intl.formatMessage({id: "DisponibilidadGridFilters.render.filtros_transportadora.label", defaultMessage: "Transportadora"})} 
                placeholder={intl.formatMessage({id: "DisponibilidadGridFilters.render.filtros_transportadora.placeholder", defaultMessage: "Transportadora"})}
              />
              )}
            />
          </form>
        </Grid>
        <Grid hidden={!props.reservaHabilitado} component={Box} item xs={3}>
          <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
            <Autocomplete
              size="small"
              name="esReserva"
              options={[
                  {value: 'true', label: intl.formatMessage({id: "disponibilidadGrid.render.filtros_esReserva.si", defaultMessage: "Si"})},
                  {value: 'false', label: intl.formatMessage({id: "disponibilidadGrid.render.filtros_esReserva.no", defaultMessage: "No"})}
                ]}
              value={filtersState.esReserva}
              defaultValue={null}
              getOptionLabel={(option) => option ? option.label : ""}
              onChange={(e, value) => handleChange('esReserva', value)}
              renderInput={(params) => (
                <TextField {...params} variant="standard"
                  label={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_esReserva.label", defaultMessage: "Es Reserva" })}
                  placeholder={intl.formatMessage({ id: "disponibilidadGrid.render.filtros_esReserva.placeholder", defaultMessage: "Es Reserva" })}
                />
              )}
            />
          </form>
        </Grid>
        <Grid
          xs={12}
          container
          justifyContent="space-between"
          alignItems="center"
          flexDirection={{ xs: 'column', sm: 'row' }}
          sx={{ fontSize: '12px' }}
        >
          <Grid component={Box} item xs={2} className="align-self-end">
            <div className="d-flex inline justify-content-around align-items-center">
              <FormattedMessage
                id="disponibilidadGrid.render.filtros.persistir_filtros"
                defaultMessage="Persistir Filtros"
              />
              <Switch
                onChange={(value) => onChangePersistentFilter(value)}
                checked={props.persisteFiltros}
                disabled={filtersLoading}
                offColor="#FF4961"
                onColor="#28D094"
              />
            </div>
          </Grid>
          <Grid component={Box} item xs={1} className="align-self-end"
          >
            <button
              disabled={props.loading || validatorSearch}
              className="btn btn-primary mr-1"
              onClick={(e) => handleSubmit(e)}
            >
              <i className="fa fa-search fa-xs"></i>   <FormattedMessage id="Buscar" defaultMessage="Buscar"/>
            </button>
          </Grid>
        </Grid>
      </Grid>
    </Collapse>
}
  </>
)
}

export default DisponibilidadGridFilters

